module.exports = __webpack_public_path__ + "img/item_img3.60916437.png";